import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { BASE_URL } from "../CommonApi";
import swal from "sweetalert";
import { AES, enc } from "crypto-js";

const CandidateDetails = ({ id, onCancel }) => {
  const encryptedUniqueId = localStorage.getItem("uniqueId1");
  const decryptedUniqueId = AES.decrypt(
    encryptedUniqueId,
    "1234567812345678"
  ).toString(enc.Utf8);
  const jwtToken = localStorage.getItem("jwtToken");
  const [documents, setDocuments] = useState({});
  const documentNameMapping = {
    resume: "Resume",
  };

  const [candidateName, setCandidateName] = useState("");
  const [department, setDepartment] = useState("");
  const [position, setPosition] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [alternateContact, setAlternateContact] = useState("");
  const [email, setEmail] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [maritalStatus, setMaritalStatus] = useState("");
  const [experience, setExperience] = useState("");
  const [topThreeSkills, setTopThreeSkills] = useState([]);
  const [certificates, setCertificates] = useState("");
  const [highestQualification, setHightestQualification] = useState("");
  const [howDidYouHere, setHowDidYouHere] = useState("");

  useEffect(() => {
    const fetchCandidateData = async () => {
      try {
        const response = await fetch(`${BASE_URL}/getCandidateById`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({ id: String(id) }),
        });
        const data = await response.json();
        if (response.ok) {
          const Data = data.data;
          setCandidateName(Data.name);
          setDepartment(Data.department);
          setPosition(Data.position);
          setContactNumber(Data.mobileNumber);
          setAlternateContact(Data.alternateMobileNumber);
          setEmail(Data.email);
          setDob(Data.dateOfBirth);
          setGender(Data.gender);
          setCertificates(Data.certificate);
          setMaritalStatus(Data.maritalStatus);
          setExperience(Data.experience);
          setTopThreeSkills(Data.topThreeSkills);
          setHowDidYouHere(Data.howDidYouHearAboutUs);
          setHightestQualification(Data.highestEducationQualification);

          const documentFiles = {
            resume: data.data.resume,
          };
          setDocuments(documentFiles);
        } else {
          console.error("Failed to fetch candidate data");
        }
      } catch (error) {
        console.error("Error fetching candidate data:", error);
      }
    };

    fetchCandidateData();
  }, [id]);

  const handleCancleClick = () => {
    onCancel();
  };

  const openDocument = (fileName) => {
    const documentUrl = `https://trading.zarpsoftware.in/uploads/HrsCandidateData/${fileName}`;
    window.open(documentUrl, "_blank");
  };
  return (
    <Container fluid className="py-4">
      <Row>
        <Col>
          <div className="my-3">
            <div className="px-2 d-flex">
              <div className="cursor-pointer d-flex justify-content-center align-items-center back-button">
                <ArrowBackIosIcon
                  width={2}
                  className="arrow-child"
                  onClick={handleCancleClick}
                />
              </div>
              <h5
                className="mt-1 mx-2 text-primary"
                style={{ letterSpacing: "1px" }}
              >
                Candidate Details
              </h5>
            </div>
          </div>

          <Card className="shadow-sm card-style">
            <Card.Body>
              <Row>
                <Col md={6}>
                  <div
                    className="bg-light p-3 rounded mb-3"
                    style={{
                      // maxHeight: "370px",
                      height: "100%",
                    }}
                  >
                    <h5 className="text-primary mb-3">Candidate Information</h5>
                    <p className="p-3 mb-2 border-bottom border-1 border-grey">
                      <strong>Candidate ID:</strong> {id}
                    </p>
                    <p className="p-3 mb-2 border-bottom border-1 border-grey">
                      <strong>Candidate Name:</strong> {candidateName}
                    </p>
                    <p className="p-3 mb-2 border-bottom border-1 border-grey">
                      <strong>Candidate Position:</strong> {position}
                    </p>
                    <p className="p-3 mb-2 border-bottom border-1 border-grey">
                      <strong>Permenent Certificates:</strong> {certificates}
                    </p>
                    <p className="p-3 mb-2 border-bottom border-1 border-grey">
                      <strong>Top Three Skills:</strong> {topThreeSkills}
                    </p>
                    <p className="p-3 mb-2 border-bottom border-1 border-grey">
                      <strong>Highest Qualification:</strong>{" "}
                      {highestQualification}
                    </p>
                    <p className="p-3 mb-2 border-bottom border-1 border-grey">
                      <strong>How did you here about us:</strong>{" "}
                      {howDidYouHere}
                    </p>
                  </div>
                </Col>
                <Col md={6}>
                  <div
                    className="bg-light p-3 rounded mb-3"
                    style={{
                      // maxHeight: "370px",
                      height: "100%",
                    }}
                  >
                    <h5 className="text-primary mb-3">Personal Information</h5>
                    <p className="p-3 mb-2 border-bottom border-1 border-grey">
                      <strong>Candidate Email:</strong> {email}
                    </p>
                    <p className="p-3 mb-2 border-bottom border-1 border-grey">
                      <strong>Candidate Contact:</strong> {contactNumber}
                    </p>
                    <p className="p-3 mb-2 border-bottom border-1 border-grey">
                      <strong>Candidate Alternate Contact:</strong>{" "}
                      {alternateContact}
                    </p>
                    <p className="p-3 mb-2 border-bottom border-1 border-grey">
                      <strong>Candidate Date of Birth:</strong> {dob}
                    </p>
                    <p className="p-3 mb-2 border-bottom border-1 border-grey">
                      <strong>Candidate Gender:</strong> {gender}
                    </p>
                    <p className="p-3 mb-2 border-bottom border-1 border-grey">
                      <strong>Marital Status</strong> {maritalStatus}
                    </p>
                    <p className="p-3 mb-2 border-bottom border-1 border-grey">
                      <strong>Candidate Experience:</strong> {experience} Years
                    </p>
                  </div>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col>
                  <h5 className="text-primary mb-3">Candidate Documents</h5>
                  <div className="bg-light p-3 rounded">
                    <Row>
                      {Object.entries(documents).map(([docName, fileName]) => (
                        <Col md={4} key={docName} className="mb-2">
                          <div
                            className="position-relative w-100"
                            title={
                              fileName
                                ? "Click to view document"
                                : "Document not available"
                            }
                          >
                            <button
                              onClick={() => fileName && openDocument(fileName)}
                              className={`w-100 btn ${
                                fileName ? "btn-primary" : "btn-danger"
                              }`}
                              style={{
                                cursor: fileName ? "pointer" : "not-allowed",
                              }}
                            >
                              {/* {docName
                                .replace(/([A-Z])/g, " $1")
                                .replace(/^./, (str) => str.toUpperCase())} */}
                              {documentNameMapping[docName] || docName}
                            </button>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default CandidateDetails;
